import { mobile } from "../../../mediaQueries"

const styles = theme => ({
    root: {
        width: '100%',
        maxWidth: '1200px',
        marginTop: '2rem',
        position: 'relative',
        height: '100%',
        opacity: 0,
        transition: 'opacity 2.5s cubic-bezier(.4,.28,0,1.03)',
        [theme.breakpoints.down(theme.breakpoints.values.xs + mobile)]: {
            width: '100%'
        }
    },
    img: {
        height: '100%',
        width: '100%',
        objectFit: 'cover',
        zIndex: 1000,
        [theme.breakpoints.down(theme.breakpoints.values.xs + mobile)]: {
            minHeight: '500px'
        }
    }
})

export default styles